var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "el-select",
            {
              class: "wp-10",
              attrs: {
                filterable: "",
                multiple: _vm.filter.inputs.choice.multiple
              },
              model: {
                value: _vm.choice,
                callback: function($$v) {
                  _vm.choice = $$v
                },
                expression: "choice"
              }
            },
            _vm._l(_vm.filter.inputs.choice.options, function(option) {
              return _c(
                "el-option",
                {
                  key: "opt-" + option.value,
                  attrs: { label: option.label, value: option.value }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(option.label) +
                      "\n                "
                  )
                ]
              )
            }),
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }